<template>
  <div class="container-wrapper">
    <div class="select-video-group">
      <div
        v-for="group in groupList"
        :key="group.group_id"
        :class="['group-item', { all: group.group_id === '' }, { selected: selectedItem.group_id === group.group_id }]"
        @click="changeGroup(group)"
      >
        <span :title="group.name" class="group-item-content">
          <span class="name">{{ group.name }}</span>
          <span class="count">({{ group.count }})</span>
        </span>
      </div>
    </div>
    <div class="select-video-content">
      <div class="content-header">
        <span class="name">{{ selectedItem.name }}({{ selectedItem.count }})</span>
        <a-input-search v-model:value="searchKey" class="search-input" placeholder="搜索视频名称" enter-button @search="getVideoList()"></a-input-search>
      </div>
      <div class="content-body">
        <div class="item" v-for="(item, index) in videoList" :key="index" @click="videoCheck(index)">
          <img :src="item.video_img" class="video-first-frame" />
          <div class="video-title">{{ item.name }}</div>
          <div class="video-size">
            <p>
              {{ handleVideoSize(item.size) }}
            </p>
          </div>
          <a-checkbox class="video-checkbox" :checked="item.checked" @click.stop="videoCheck(index)" />
        </div>
      </div>
      <div class="content-footer">
        <a-pagination
          :showSizeChanger="false"
          size="small"
          v-model:current="page"
          v-model:pageSize="pageSize"
          :total="parseInt(count)"
          :show-total="(total) => `共 ${total} 条`"
          @change="getVideoList()"
        ></a-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import { getMaterialList as getMaterialListAPI, getMaterialGroupList as getMaterialGroupListAPI } from '@/api/system/imageGroup'
  import dayjs from 'dayjs'
  import durationPlugin from 'dayjs/plugin/duration'
  dayjs.extend(durationPlugin)
  const TYPE = 2 // 整型; 默认值: 1; 素材类型 1-图片 2-视频
  export default {
    name: 'SelectVideo',
    props: {
      // 最多能选几个视频
      limitNumber: {
        type: Number,
        default() {
          return 2
        },
      },
      // 视频最大size, 最大2GB
      limitObj: {
        type: Object,
        default() {
          return {
            text: '2GB',
            size: 2 * 1024 * 1024 * 1024,
          }
        },
      },
      groupId: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        originGroupList: [],
        groupList: [],
        selectedId: this.groupId || '', // 默认是选的全部(分组)
        selectedItem: {}, // 选取分组的内容

        videoList: [], // 视频具体内容
        selectedVideoList: [],

        searchKey: '', // 用户输入的关键字查询
        page: 1, // 当前页,
        pageSize: 10, // 页大小
        count: 0, // 总共多少条视频
      }
    },
    methods: {
      getGroupList() {
        getMaterialGroupListAPI({ type: TYPE }).then((res) => {
          if (parseInt(res.code) === 0) {
            const groups = res.data
            this.originGroupList = groups
            let countAll = 0
            groups.forEach((v) => {
              countAll += parseInt(v.count)
            })
            this.groupList = [{ group_id: '', name: '全部', count: countAll }, ...groups]
            const item = this.groupList.find((v) => v.group_id === this.selectedId)
            let index = this.groupList.findIndex((v) => v.group_id === this.selectedId)
            if (item) {
              this.selectedItem = item
            } else {
              this.selectedItem = this.groupList[0]
              index = 0
            }
            this.selectedId = this.selectedItem.group_id
            const indexHeight = 40 * (index + 1) + 15
            if (indexHeight > 460) {
              this.$nextTick(() => {
                document.querySelector('.select-video-group').scrollTop = indexHeight - 200
              })
            }
            this.getVideoList()
          }
        })
      },
      changeGroup(item) {
        this.selectedItem = item
        this.selectedId = item.group_id
        this.page = 1
        this.getVideoList()
      },
      getVideoList() {
        const body = {
          group_id: this.selectedId, // 空为查全部，0为查未分组
          keyword: this.searchKey, // 视频名称关键字查询
          page: this.page,
          pageSize: this.pageSize,
          type: TYPE,
        }
        getMaterialListAPI(body).then((res) => {
          if (res.code === 0) {
            this.count = res.data.count
            this.videoList = res.data.list.map((v) => {
              v.checked = false
              return v
            })
          } else {
            this.videoList = []
          }
        })
      },
      // 视频打勾
      videoCheck(index) {
        // 如果已经选择了, 则再选一次为取消
        // a: 取消
        if (this.videoList[index].checked === true) {
          this.videoList[index].checked = false
          let currIndex = this.selectedVideoList.findIndex((item) => {
            return item === index
          })
          if (currIndex === -1) {
            console.error('发生问题, 文件名SelectVideo, 视频打勾出现问题')
            return
          }
          this.selectedVideoList.splice(currIndex, 1)
        }
        // b: 选择
        else {
          // 如果超过允许的视频数量
          if (this.limitNumber === 1) {
            if (this.videoList[index].size > this.limitObj.size) {
              return this.$message.error('所选视频不能大于' + this.limitObj.text)
            }
            if (this.selectedVideoList.length >= this.limitNumber) {
              let preIndex = this.selectedVideoList.shift()
              this.videoList[preIndex].checked = false
            }
            this.videoList[index].checked = true
            this.selectedVideoList.push(index)
          } else {
            if (this.selectedVideoList.length >= this.limitNumber) {
              this.$message.error(`最多选择 ${this.limitNumber} 个视频`)
              return
            }
            if (this.videoList[index].size > this.limitObj.size) {
              return this.$message.error('所选视频不能大于' + this.limitObj.text)
            }
            this.videoList[index].checked = true
            this.selectedVideoList.push(index)
          }
        }
      },
      // 检查是否选择了视频
      checkInfo() {
        return this.selectedVideoList.length > 0
      },
      getInfo() {
        let resArr = []
        this.selectedVideoList.forEach((item) => {
          resArr.push(this.videoList[item].url)
        })
        return resArr
      },
      // 获取时长
      getDuration: function (duration) {
        let hh = dayjs.duration(duration, 'seconds').hours().toString()
        if (hh.length === 1) {
          hh = '0' + hh
        }
        let mm = dayjs.duration(duration, 'seconds').minutes().toString()
        if (mm.length === 1) {
          mm = '0' + mm
        }
        let ss = dayjs.duration(duration, 'seconds').seconds().toString()
        if (ss.length === 1) {
          ss = '0' + ss
        }
        return `${hh}:${mm}:${ss}`
      },
      // 处理视频大小显示, 传进来的单位为B
      handleVideoSize(size) {
        if (size === 0) {
          return '未知大小'
        } else {
          let size_kb = size / 1024
          if (size_kb > 1024) {
            return parseFloat(size_kb / 1024).toFixed(1) + ' MB'
          } else {
            return parseFloat(size_kb).toFixed(1) + ' KB'
          }
        }
      },
    },
    created() {
      this.getGroupList()
    },
  }
</script>

<style lang="scss" scoped>
  .container-wrapper {
    display: flex;
    flex-flow: row;
    .select-video-group {
      flex: 1;
      height: 460px;
      overflow: scroll;
      background-color: rgb(245, 246, 248);
      padding: 15px 10px;
      .group-item {
        height: 40px;
        line-height: 40px;
        padding: 0 10px 0 20px;
        border-radius: 5px;
        margin-bottom: 5px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        .group-item-content {
          flex: 1;
          display: flex;
          overflow: hidden;
          .name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .count {
            flex: 1;
          }
        }
      }
      .all {
        font-weight: bold;
        padding-left: 10px;
      }
      .selected {
        background-color: #eaecf0;
      }
    }
    .select-video-content {
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-between;
      margin-left: 10px;
      padding: 15px 0 15px 15px;
      flex: 4;
      .content-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        .name {
          font-size: 16px;
        }
        .search-input {
          width: 250px;
        }
      }
      .content-body {
        flex: 3;
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        width: 100%;
        .item {
          margin: 0 8px 15px;
          width: calc(20% - 16px);
          cursor: pointer;
          position: relative;
          .video-first-frame {
            width: 100%;
            height: 110px;
            object-fit: cover;
          }
          .video-title {
            width: 100%;
            margin-top: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .video-size {
            width: 100%;
            margin-top: 5px;
            font-size: 12px;
            color: #999;
          }
          .video-checkbox {
            position: absolute;
            top: 4px;
            right: 4px;
          }
        }
      }
      .content-footer {
        align-self: center;
        display: flex;
        justify-content: center;
        align-items: center;
        .ant-pagination {
          margin-top: 0;
        }
      }
    }
  }
</style>
